import searchList from './common/searchList';
import labelCondition from './common/labelCondition';
import mmSelect from './common/mmSelect';
import fileUpload from './common/fileUpload';
import monthPicker from './common/monthPicker';
import mmTable from './common/mmTable';
import tabTitle from './common/tabTitle';
import getDetail from './common/getDetail';
import mmRadio from './common/mmRadio';
import mmMenuItem from './common/mmMenuItem';
import inputNumberPercent from './common/inputNumberPercent';
import summaryColumn from './common/summaryColumn';
import multiInput from './common/multiInput';
import numberInput from './common/numberInput';
import tfSelect from './common/tfSelect';
import numberRange from './common/numberRange';
import mmNotify from './common/mmNotify.vue';
import mmEditor from './common/mmEditor.vue';
import dictSelect from './common/dictSelect.vue'


//adv
import advStatus  from './adv/advStatus';
import advAccountLevel  from './adv/advAccountLevel';
import advType  from './adv/advType';
import advTrackPlatform from './adv/advTrackPlatform';
import advApiUrl from './adv/advApiUrl';
import advDetail from './adv/advDetail';
import advRuleOfferCvrRule from './adv/advRuleOfferCvrRule';
import advSelect from './adv/advSelect';
import advFilterSelect from './adv/advFilterSelect';

//finance
import summaryStatus from './finance/summaryStatus';
import summaryAmountStatus from './finance/summaryAmountStatus';
import offerAmountStatus from './finance/offerAmountStatus';
import invoiceStatus from './finance/invoiceStatus';
import amountReason from './finance/amountReason';
import payoutTypeSelect from './finance/payoutTypeSelect';

//channel
import channelSelect from './channel/channelSelect';
import channelAccountLevel from './channel/channelAccountLevel';
import channelType from './channel/channelType';
import channelPostback from './channel/channelPostback';
import channelDetail from './channel/channelDetail';
import channelApiFilterRule from './channel/channelApiFilterRule';
import channelFilterRuleType from  './channel/channelFilterRuleType';
import channelSubs from './channel/channelSubs';
import RuleList from './channel/ruleList';
import advChannelRuleStatus from './adv/advChannelRuleStatus';
import channelFilterSelect from './channel/channelFilterSelect';

//report
import timeZone from './report/timeZone';
import reportSelectModel from './report/reportSelectModel';
import reportGroupModel from './report/reportGroupModel';
import dateRange from './common/dateRange';
import topIpGroupModel from './report/topIpGroupModel';

//offer
import offerPlatform from './offer/offerPlatform';
import offerStatus from './offer/offerStatus';
import offerManualStatus from './offer/offerManualStatus';
import offerGeos from './offer/offerGeos';
import offerPricingModel from './offer/offerPricingModel';
import offerTrafficType from './offer/offerTrafficType';
import offerCategory from './offer/offerCategory';
import offerCurrency from './offer/offerCurrency';

//user
import userSelect  from './user/userSelect';
import groupSelect from './user/groupSelect';
import userInfo from './user/userInfo';

//datanalyze
import campareOption from './datanalyze/campareOption';
import camparePeriod from './datanalyze/camparePeriod';
import lineChart from './datanalyze/chart';
import pieChart from './datanalyze/pieChart';

// log
import logGroupModel from './log/logGroupModel';
import traceResult from './log/traceResult';


function init(Vue){
	// base components
	Vue.component('search-list',searchList);
	Vue.component('mm-lc',labelCondition);
	Vue.component('mm-select',mmSelect);
	Vue.component('mm-upload',fileUpload);
	Vue.component('mm-month-picker',monthPicker);
	Vue.component('mm-table',mmTable);
	Vue.component('mm-tab-title',tabTitle);
	Vue.component('mm-get-detail',getDetail);
	Vue.component('mm-radio',mmRadio);
	Vue.component('mm-rule-list',RuleList);
	Vue.component('mm-menu-item',mmMenuItem);
	Vue.component('mm-input-number-percent',inputNumberPercent);
	Vue.component('mm-summary-column',summaryColumn);
	Vue.component('mm-multi-input',multiInput);
	Vue.component('mm-number-input', numberInput);
	Vue.component('mm-tf-select', tfSelect);
	Vue.component('mm-number-range',numberRange);
	Vue.component('mm-notify', mmNotify);
	Vue.component('mm-editor', mmEditor);
	Vue.component('mm-dict-select', dictSelect);


	// adv 
	Vue.component('mm-adv-status',advStatus);
	Vue.component('mm-adv-accountlevel',advAccountLevel);
	Vue.component('mm-adv-type',advType);
	Vue.component('mm-adv-track-platform',advTrackPlatform);
	Vue.component('mm-adv-api-url',advApiUrl);
	Vue.component('mm-adv-detail',advDetail);
	Vue.component('mm-adv-rule-offer-cvr-rule',advRuleOfferCvrRule);
	Vue.component('mm-adv-select',advSelect);
	Vue.component('mm-adv-filter-select',advFilterSelect);

	// channel
	Vue.component('mm-channel-select',channelSelect);
	Vue.component('mm-channel-accountlevel',channelAccountLevel);
	Vue.component('mm-channel-type',channelType);
	Vue.component('mm-channel-postback',channelPostback);
	Vue.component('mm-channel-detail',channelDetail);
	Vue.component('mm-channel-api-filter-rule',channelApiFilterRule);
	Vue.component('mm-channel-filter-rule-type',channelFilterRuleType);
	Vue.component('mm-channel-subs',channelSubs);
	Vue.component('mm-adv-channel-rule-status', advChannelRuleStatus);
	Vue.component('mm-channel-filter-select', channelFilterSelect);


	// report
	Vue.component('mm-time-zone',timeZone);
	Vue.component('mm-report-select-model',reportSelectModel);
	Vue.component('mm-report-group-model',reportGroupModel);
	Vue.component('mm-topip-group-model',topIpGroupModel);
	Vue.component('mm-date-range',dateRange);

	// offer
	Vue.component('mm-offer-platform',offerPlatform);
	Vue.component('mm-offer-status',offerStatus);
	Vue.component('mm-offer-manualstatus',offerManualStatus);
	Vue.component('mm-offer-geos',offerGeos);
	Vue.component('mm-offer-pricing-model',offerPricingModel);
	Vue.component('mm-offer-traffic-type',offerTrafficType);
	Vue.component('mm-offer-category',offerCategory);
	Vue.component('mm-offer-currency',offerCurrency);

	// user 
	Vue.component('mm-users',userSelect);
	Vue.component('mm-group',groupSelect);
	Vue.component('user-info',userInfo);

	// finance
	Vue.component('mm-summary-status',summaryStatus);
	Vue.component('mm-summary-amount-status',summaryAmountStatus);
	Vue.component('mm-offer-amount-status',offerAmountStatus);
	Vue.component('mm-invoice-status',invoiceStatus);
	Vue.component('mm-amount-reason',amountReason);
	Vue.component('mm-payout-type-select',payoutTypeSelect);

	//datanalyze
	Vue.component('mm-campare-option',campareOption);
	Vue.component('mm-campare-period',camparePeriod);
	Vue.component('mm-line-chart',lineChart);
	Vue.component('mm-pie-chart',pieChart);

	// log
	Vue.component('mm-log-group-model',logGroupModel);
	Vue.component('mm-trace-result',traceResult);


}
export default init